import { render } from "./Undo.vue.js?vue&type=template&id=800cb230!=!../vue-loader/dist/index.js??ruleSet[0]!./Undo.vue?vue&type=template&id=800cb230"
import script from "./Undo.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Undo.vue?vue&type=script&lang=js"
export * from "./Undo.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Undo.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__